module.exports = __webpack_public_path__ + "assets/img/btn-view-d2a544fa.png";